export default (axios, baseURL) => {
    return {
        index(page = 1, search = "", perPage = 8, type = "") {
            return axios.get(`${baseURL}/api/landing-plans`, {
                params: {
                    page,
                    search: search.trim(),
                    type: type || "",
                    per_page: perPage,
                    cache: Date.now(),
                },
            });
        },


        list() {
            return axios.get(`${baseURL}/api/landing-plans`, {
                params: {
                    per_page: 100,
                },
            });
        },

        show(id) {
            return axios.get(`${baseURL}/api/landing-plans/${id}`);
        },

        benefits(search = "") {
            return axios.get(`${baseURL}/api/landing-benefits`, {
                params: { search: search.trim() },
            });
        },

        create(data) {
            return axios.post(
                `${baseURL}/api/landing-plans`,
                data
            );
        },

        update(id, data) {
            data.append('_method', 'PUT');

            return axios.post(
                `${baseURL}/api/landing-plans/${id}`,
                data
            );
        },

        delete(id) {
            return axios.delete(
                `${baseURL}/api/landing-plans/${id}`
            );
        },
    };
};
